export default __webpack_public_path__ + "static/media/progress-circle-5.3ff6cfff.svg";